<template>
  <div>
    <h3 class="text-center">填写咨询方案前置问卷（3/3）</h3>
    <el-card class="box-card">
      <p>本页请补充一些基本信息，以便让咨询师对你有更全面的了解。</p>
      <br>
      <el-form :model="preQuizPart3" :rules="rules" ref="formStep3" label-position="top">
        <el-form-item label="9、原就读学校（如有转换）">
          <el-input v-model="preQuizPart3.origUniversity"></el-input>
        </el-form-item>
        <el-form-item label="10、原专业（如有转换）">
          <el-input v-model="preQuizPart3.origMajor"></el-input>
        </el-form-item>
        <el-form-item label="11、婚恋状况" prop="marriage">
          <el-radio-group v-model="preQuizPart3.marriage">
            <el-radio label="单身"></el-radio>
            <br/>
            <el-radio label="恋爱"></el-radio>
            <br/>
            <el-radio label="已婚有娃"></el-radio>
            <br/>
            <el-radio label="已婚无娃"></el-radio>
            <br/>
            <el-radio label="其他"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="12、健康状况" prop="health">
          <el-radio-group v-model="preQuizPart3.health">
            <el-radio label="良好"></el-radio>
            <br/>
            <el-radio label="常期患有某种疾病"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="13、是否接受过职业生涯咨询" prop="consultCareer">
          <el-radio-group v-model="preQuizPart3.consultCareer">
            <el-radio label="是"></el-radio>
            <br/>
            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="14、是否接受过心里咨询" prop="consultMind">
          <el-radio-group v-model="preQuizPart3.consultMind">
            <el-radio label="是"></el-radio>
            <br/>
            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="15、目前是否正在接受其他辅导" prop="consultDoing">
          <el-radio-group v-model="preQuizPart3.consultDoing">
            <el-radio label="是"></el-radio>
            <br/>
            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="16、你还想让咨询师了解些什么？">
          <el-input type="textarea" :rows="2" v-model="preQuizPart3.consultLeft"></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <br>
    <el-button type="primary" round style="width:100%" @click="submit">提 交</el-button>
    <br>
    <br>
  </div>
</template>

<script>
import {mapState} from "vuex";
import axios from "axios";
import qs from "qs";
import HttpRequest from "@/utils/request";

export default {
  name: "fillin",
  data() {
    return {
      preQuizPart3: {
        origUniversity: '',
        origMajor: '',
        marriage: '',
        health: '',
        consultCareer: '',
        consultMind: '',
        consultDoing: '',
        consultLeft: '',
      },
      rules: {
        marriage: [
          {required: true, message: '请选择婚恋状况', trigger: 'change'},
        ],
        health: [
          {required: true, message: '请选择健康状况', trigger: 'change'},
        ],
        consultCareer: [
          {required: true, message: '请选择', trigger: 'change'},
        ],
        consultMind: [
          {required: true, message: '请选择', trigger: 'change'},
        ],
        consultDoing: [
          {required: true, message: '请选择', trigger: 'change'},
        ],
      }
    };
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },
  mounted() {
  },
  methods: {
    submit() {
      this.$refs["formStep3"].validate((valid) => {
        if (valid) {
          sessionStorage.setItem("preQuizPart3", JSON.stringify(this.preQuizPart3));
          this.addAppointWithPreQuiz();
        } else {
          return false;
        }
      });
    },
    addAppointWithPreQuiz() {
      let addAppoint = JSON.parse(sessionStorage.getItem("addAppoint"));
      let preQuizPart1 = JSON.parse(sessionStorage.getItem("preQuizPart1"));
      let preQuizPart2 = JSON.parse(sessionStorage.getItem("preQuizPart2"));
      let preQuizPart3 = JSON.parse(sessionStorage.getItem("preQuizPart3"));

      let educations = [], experiences = [], careerAfraids = [], completeWords = [];
      //1$1<沈阳大学,2<本科,3<1998
      for (let i = 0; i < preQuizPart2.educations.length; i++) {
        let education = preQuizPart2.educations[i];
        educations.push((i + 1) + '$1<' + education.university + ',2<' + education.degree + ',3<' + education.year);
      }
      //1$1<软件工程师,2<北京仁能达教育,3<兼职,4<2021.10~2022.01,5<3000/月
      for (let i = 0; i < preQuizPart2.experiences.length; i++) {
        let experience = preQuizPart2.experiences[i];
        experiences.push((i + 1) + '$1<' + experience.position + ',2<' + experience.org + ',3<' + experience.jobType + ',4<' + experience.period + ',5<' + experience.salary);
      }
      ;
      //1$工作与专业不对口}2$公司破产}3$公司政治斗争复杂}4$家族公司}5$技能得不到提升
      for (let i = 0; i < preQuizPart2.careerAfraids.length; i++) {
        let careerAfraid = preQuizPart2.careerAfraids[i];
        careerAfraids.push((i + 1) + '$' + careerAfraid);
      }
      ;
      //1$压力大，不想工作}2$无法突破，看不到希望}3$掌控感，被人认可
      for (let i = 0; i < preQuizPart2.completeWords.length; i++) {
        let completeWord = preQuizPart2.completeWords[i];
        completeWords.push((i + 1) + '$' + completeWord);
      }
      ;

      let data = {
        token: this.student.token,
        scheduleId: addAppoint.id,
        consultQuestion: preQuizPart1.consultQuestion,
        resolve: preQuizPart1.resolve,
        resolveOther: preQuizPart1.resolveOther,
        effect: preQuizPart1.effect,
        educations: educations,
        experiences: experiences,
        careerAfraids: careerAfraids,
        initialWish: preQuizPart2.initialWish,
        completeWords: completeWords,
        origUniversity: preQuizPart3.origUniversity,
        origMajor: preQuizPart3.origMajor,
        marriage: preQuizPart3.marriage,
        health: preQuizPart3.health,
        consultCareer: preQuizPart3.consultCareer,
        consultMind: preQuizPart3.consultMind,
        consultDoing: preQuizPart3.consultDoing,
        consultLeft: preQuizPart3.consultLeft,
      };
      const options = {
        method: "POST",
        headers: {"content-type": "application/x-www-form-urlencoded"},
        data: qs.stringify(data, {arrayFormat: 'repeat'}),
        url: "/constub/addAppointWithPreQuiz",
      };
      axios(options).then((res) => {
        res = res.data;
        if (res.result.success) {
          this.$router.push('/appointSuccess?scheduleId=' + addAppoint.id + '&pathfrom=home')
        } else {
          this.$alert(res.result.message, {
            confirmButtonText: '确定',
            showClose: false,
          });
        }
      });
    }
  }
};
</script>


<style scoped>
>>> .el-form-item__label {
  line-height: 20px;
}

>>> .el-checkbox__label {
  display: inline-grid;
  width: 300px;
  white-space: pre-line;
  word-wrap: break-word;
  line-height: 20px;
}

>>> .el-radio__label {
  line-height: 24px;
}
</style>
